module.exports = __webpack_public_path__ + "static/media/161007-DSC04950-10_Small.70c79ed0.jpg";